import { useMemo } from 'react';
import { useUserMetadataQueryContext } from '../../../contexts/UserMetadataQueryContext';
import { EventInfo } from '../../../domain';
import { getEventDisplayName } from '../utils/getEventDisplayName';

export const useEventDisplayName = (event: EventInfo) => {
  const {
    allLists = [],
    allChannels = [],
    allMessageTypes = [],
    isLoading,
  } = useUserMetadataQueryContext();
  const displayName = useMemo(
    () => getEventDisplayName(event, allLists, allChannels, allMessageTypes),
    [event, allLists, allChannels, allMessageTypes],
  );
  return {
    isLoading,
    displayName,
  };
};
